<script>
import headNav from '../../src/components/headNav.vue'
import {getrecharge} from "../api/api";
import {mapGetters} from "vuex";
export default {
  name: "home",
  computed:{
    ...mapGetters(['userInfo'])
  },
  components:{headNav},
  data(){
    return{
      numberText:'',
      payArr:[
        {
          header:'STARTER 1',
          price:'10',
        },
        {
          header:'STARTER 2',
          price:'50',
        },
        {
          header:'STARTER 3',
          price:'100',
        },{
          header:'STARTER 4',
          price:'200',
        },
      ],
      indexModule:0,
      price:null,
      phone:null,
      detailObj:{},
      dialogVisible:false,
      orderNo:null,
      days:null,
      type:null
    }
  },
  mounted() {
    this.price = this.payArr[0].price
    console.log('mounted')
  },
  methods:{
    pay(){
      getrecharge({
        money: this.price,
        // money: 0.01,
        id: this.userInfo.id,
      }).then(res => {
        console.log(res,'打印res')
        if(res.data.status != 200){
          this.mes(res.data.data.message,'error')
          return
        }
        this.orderNo = res.data.data.order_no
        this.dialogVisible = true

      })
    },
    mes(message,type){
      this.$message({
        message,
        type
      });
    },
    moduleClick(e,idx){
      this.indexModule = idx
      this.price = e.price

    },
  }

}
</script>

<template>
  <div style="background: rgb(241 241 241);height:1000px">
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid style="margin-bottom: 30px;margin-top: 30px">
      <b-row>
        <div class="headText">Recharge balance</div>
      </b-row>
    </b-container>
    <b-container class="ok"  fluid style="margin-bottom: 30px;margin-top: 30px;">
      <b-row style="background:#FFFFFF;border-radius:10px;padding:20px">
        <b-col>
          <b-row style="margin-top:20px">
            <b-col sm="6" v-for="(item,index) in payArr" :key="index">
              <div @click="moduleClick(item,index)" :class="index == indexModule ? 'module1' : 'module2'">
                <div>{{item.header}}</div>
                <div style="font-weight: bold">${{item.price}}</div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button block variant="primary" @click="pay">payment</b-button>
            </b-col>
            <b-col>

            </b-col>

          </b-row>
        </b-col>


        <b-col>

        </b-col>
      </b-row>
    </b-container>
    <el-dialog
      title="Choose payment method"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="">
        <div>
          <form action="https://www.coinpayments.net/index.php" method="post" target="_top">
            <input type="hidden" name="cmd" value="_pay_simple">
            <input type="hidden" name="first_name" :value="orderNo">
            <input type="hidden" name="last_name" :value="userInfo.email">
            <input type="hidden" name="email" :value="userInfo.email">
            <input type="hidden" name="item_number" :value="orderNo">
            <input type="hidden" name="reset" value="1">
            <input type="hidden" name="merchant" value="1733ff8e76a7230d0a06f57fb677d43b">
            <input type="hidden" name="currency" value="LTC">
            <input type="hidden" name="amountf" :value="price">
            <input type="hidden" name="item_name" value="Balance recharge">
<!--            <input type="hidden" name="email" :value="userInfo.email">-->
            <input type="hidden" name="success_url" value="https://freerealnumber.com/dist/#/success">
            <input type="hidden" name="cancel_url" value="https://freerealnumber.com/dist/#/cancel">
<!--            <input type="hidden" name="success_url" value="http://localhost:8080/#/BalanceDetails">-->
<!--            <input type="hidden" name="cancel_url" value="http://localhost:8080/#/BalanceDetails">-->
            <input type="image" src="https://www.coinpayments.net/images/pub/buynow-grey.png" alt="现在就购买CoinPayments.net">
          </form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.module1{
  border:1px solid #11AB69;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
  background: rgba(17,171,105,0.05);
  cursor: pointer;
}
.module2{
  border:1px solid #dbdddc;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
}
.module2:hover{
  background: rgba(17,171,105,0.05);
}
body{
  background: rgb(217, 215, 215);
}
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;

  }
}
.headText{
  font-weight: bold;
  font-size:26px;
  margin:20px 0
}
</style>



// WEBPACK FOOTER //
// src/view/BalanceDetails.vue